import React, {useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import { DropDownList, DropDownListChild } from '../../Elements/Select/dropdown'
// import SectoresSelect from './SectoresSelect'
// import LineasProductoSelect from './LineasProductoSelect'
import DatoAdicionalSelect from './DatoAdicionalSelect'
import PrioridadSelect from './PrioridadSelect'
// import TipoObjetoSelect from './TipoObjetoSelect'
import InputWithCounter from '../../Elements/InputWithCounter';
import TextareaWithCounter from '../../Elements/TextareaWithCounter';
import { Link } from 'react-router-dom';

import axios from "axios"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_URL } from '../../../constants';

function CrearNotificacion() {

    const history = useHistory();

    const [loading, setloading]             = useState(true);
    const [sending, setSending]             = useState(false);

    // const [tipoObjeto, settipoObjeto]       = useState(null);
    const [sectores, setSectores]           = useState([]);
    const [lineasProducto, setLineasProducto]  = useState([]);

const [titulo, setTitulo]                   = useState("");
    const [body, setBody]                   = useState("");
    // const [icon, seticon]                   = useState("");

    const [additional, setAdditional]       = useState({"label": 'Ninguna', "value": 'NONE'});
    const [subtitulo, setSubtitulo]       = useState("");
    const [prioridad, setPrioridad]       = useState({"label": 'High', "value": 'H'});

    const [tipoEnvio, setTipoEnvio] = useState("segmentado");

    const [actions, setActions] = useState(
        [
            {
                "actionType": "NONE",
                "label": "Ninguna",
                "description": "",
                "params": {}
            },
            {
            "actionType": "OPEN_URL",
            "label": "Abrir URL",
            "description": "Se abrirá el sitio web de la URL especificada cuando el usuario haga tap sobre la notificación.",
            "params": {
                "key": "url",
                "label": "URL del sitio web",
                "type": "text",
                "required": true
            }},
            {
            "actionType": "SHOW_NOTICE",
            "label": "Mostrar noticia",
            "description": "Se abrirá la noticia especificada en el App, cuando el usuario haga tap sobre la notificación recibida.",
            "params": {
                "key": "id",
                "label": "ID de la noticia",
                "type": "number",
                "required": true
            }},
            // {
            // "actionType": "SHOW_EVENT",
            // "label": "Mostrar evento",
            // "description": "Se abrirá el evento especificado en el App, cuando el usuario haga tap sobre la notificación recibida.",
            // "params": {
            //     "key": "id",
            //     "label": "ID del evento",
            //     "type": "number",
            //     "required": true
            // }},
            {
            "actionType": "GO_COURSES",
            "label": "Ir a Cursos",
            "description": "Se abrirá la página de Cursos en el App, cuando el usuario haga tap sobre la notificación recibida.",
            "params": {}
            },
            {
            "actionType": "GO_PROMOTION",
            "label": "Ir a Promoción",
            "description": "Se abrirá la página de Promoción en el App, cuando el usuario haga tap sobre la notificación recibida.",
            "params": {}
            },
            {
            "actionType": "GO_TRAINING",
            "label": "Ir a Entrenamiento",
            "description": "Se abrirá la página de Entrenamiento en el App, cuando el usuario haga tap sobre la notificación recibida.",
            "params": {}
            },
            {
            "actionType": "GO_STUDIE",
            "label": "Ir a Estudio",
            "description": "Se abrirá la página de Estudio en el App, cuando el usuario haga tap sobre la notificación recibida.",
            "params": {}
            }
      ]);
    
    const [param1Value, setParam1Value] = useState("");
    const [dispositivos, setDispositivos] = useState("");

    const handleClickSubmit = (e) => {
        e.preventDefault();

        let errors = 0;

        /*
        if(tipoObjeto === null){
            toast.error('Debe seleccionar un tipo de objeto');
            errors++;
        }
        */

        if(titulo === ""){
            toast.error('Debe ingresar un Título');
            errors++;
        }

        if(body === ""){
            toast.error('Debe ingresar un Cuerpo');
            errors++;
        }
        
        let param1 = actions.find(val => val.actionType == additional.value);
        param1 = (param1) ? param1.params : {};

        if(additional.value !== "NONE" && Object.keys(param1).length !== 0 && param1.required){
            if(param1.key == "url"){
                if(param1Value.indexOf("https://") !== 0){
                    toast.error('Debe ingresar una URL https válida');
                    errors++;
                }
            }else{
                if(param1Value == ""){
                    toast.error('Debe ingresar ' + param1.label);
                    errors++;
                }
            }
        }

        if(prioridad === ""){
            toast.error('Debe seleccionar una Prioridad');
            errors++;
        }

        if(tipoEnvio == 'segmentado' && (!sectores || sectores.length === 0
            ) && (!lineasProducto || lineasProducto.length === 0)){
            toast.error('Debe seleccionar al menos un Sector o Linea de producto');
            errors++;
        }

        let dispositivosArray = dispositivos.split(',').filter(r => r !== '');
        if(tipoEnvio == 'especifico' && dispositivosArray.length === 0){
            toast.error('Debe ingresar al menos un dispositivo');
            errors++;
        }

        if(errors > 0){
            return false;
        }else{
            let accionResultado = "";
            if(additional.value !== "NONE"){
                let tempParam = {}
                if (Object.keys(param1).length !== 0){
                    tempParam[param1.key] = param1Value
                }
                accionResultado = JSON.stringify({"actionType": additional.value,"params": JSON.stringify(tempParam)});
            }else{
                // Ninguno seleccionado
                accionResultado = JSON.stringify({"actionType": "NONE", "params": JSON.stringify({})});
            }

            let data = {
                noti_TipoObjeto:            "",
                noti_FirebaseTitulo:        titulo,
                noti_FirebaseSubtitulo:     subtitulo,
                noti_FirebasePrioridad:     prioridad.value,
                noti_FirebaseCuerpo:        body,
                noti_FirebaseIcono:         "",
                noti_FirebaseClicAccion:    "",
                noti_FirebaseDatoAdicional: accionResultado,
                sectores:                   (tipoEnvio == 'segmentado' && (sectores && sectores.length > 0)) ? sectores.map(v => v.value.split("-")[1]).toString() : "",
                lineasProducto:             (tipoEnvio == 'segmentado' && (lineasProducto && lineasProducto.length > 0)) ? lineasProducto.map(v => v.value).toString() : "",
                dispositivos:               tipoEnvio == 'especifico' ? dispositivos.split(',').filter(r => r !== '') : []
            }
            console.log(data);

            const url = `${API_URL}NotificacionUX/InsertarNotificacionManual`;
            
            setSending(true);

            const formData = JSON.stringify(data);
            axios.post(
                url,
                JSON.stringify(formData),
                {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8' ,
                        'Accept': 'application/json'
                    }
                }
            ).then(data => {
                console.log(data);
                history.push(`/notificaciones`);
                toast.success('Notificación creada con éxito');
                setSending(false);
            }).catch((error)=> {
                console.error(error);
                setSending(false);
            });
            
        }
    }

    const actualizarSectores = (e) => {
        let value = e.target.value;
        setSectores(value);
        setLineasProducto("");
    }

    return (
        <div>
            <div className="divContenedorBreadcrumbs">
                <div className="divCenterBreadcrumbs">
                    <img src="/static/images/icoBreadcrumb.png" alt="icon home" />
                        <a href="/">
                            / Panel de Configuración General
                        </a>
                        <Link to="/notificaciones">
                            / Notificaciones
                        </Link>
                        <span> / Crear Notificación Manual</span>
                </div>
            </div>
            <div className="divTitulo_Panel">
                Crear Notificación Manual
            </div>
            <div id="detailBody" className="Site-content" >
                <div 
                    //className="loader"
                ></div>
                <form id="frmResource" name="frmResource" 
                onSubmit={(e) => handleClickSubmit(e)} 
                >
                    <div className="container pt-4">
                        <div className="row justify-content-center">

                            <div className="col-lg-8">
                                <div className="boletin__filters section__margin-bottom">

                                    {/* 
                                    <div className="form-group">
                                        <label htmlFor="noti_FirebaseTitulo">
                                            <strong>Tipo de objeto</strong>
                                        </label>
                                        <div>
                                            <TipoObjetoSelect 
                                                value={tipoObjeto}
                                                onChange={(value) => settipoObjeto(value)}
                                            />
                                        </div>
                                    </div>
                                    */}

                                    <div className="form-group">
                                        <label htmlFor="noti_FirebaseTitulo">
                                            <strong>Título de la notificación *</strong>
                                        </label>
                                        <InputWithCounter
                                            name="noti_FirebaseTitulo" 
                                            id="noti_FirebaseTitulo" 
                                            onChange={(e) => setTitulo(e.target.value)} 
                                            defaultValue={titulo}  
                                            count={titulo}
                                            maxlength={500}
                                            placeholder="Título"
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label htmlFor="noti_FirebaseSubtitulo">
                                            <strong>Subtítulo de la notificación (solo iOS)</strong>
                                        </label>
                                        <InputWithCounter
                                            name="noti_FirebaseSubtitulo" 
                                            id="noti_FirebaseSubtitulo" 
                                            onChange={(e) => setSubtitulo(e.target.value)} 
                                            defaultValue={subtitulo}  
                                            count={subtitulo}
                                            maxlength={500}
                                            placeholder="Subtítulo"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="noti_FirebaseCuerpo">
                                            <strong>Cuerpo de la notificación *</strong>
                                        </label>
                                        <TextareaWithCounter
                                            name="noti_FirebaseCuerpo" 
                                            id="noti_FirebaseCuerpo" 
                                            onChange={(e) => setBody(e.target.value)} 
                                            defaultValue={body} 
                                            count={body}
                                            maxlength={1000}
                                        />
                                    </div>

                                    {/* <div className="form-group">
                                        <label htmlFor="noti_FirebaseIcono">
                                            <strong>Enlace de ícono</strong>
                                        </label>
                                        <input 
                                            type="text" 
                                            name="noti_FirebaseIcono" 
                                            id="noti_FirebaseIcono" 
                                            onChange={(e) => seticon(e.target.value)} 
                                            defaultValue={icon} 
                                            className="form-control text-filter__form-control" 
                                            placeholder="url" 
                                        />
                                    </div> */}

                                    {/* 
                                    <div className="form-group">
                                        <label htmlFor="noti_FirebaseClicAccion">
                                            <strong>Acción</strong>
                                        </label>
                                        <input 
                                            type="text" 
                                            name="noti_FirebaseClicAccion" 
                                            id="noti_FirebaseClicAccion" 
                                            onChange={(e) => setaction(e.target.value)} 
                                            defaultValue={action} 
                                            className="form-control text-filter__form-control" 
                                            placeholder="Acción" 
                                        />
                                    </div>
                                    */}

                                    <div className="form-group">
                                        <label htmlFor="noti_FirebaseDatoAdicional">
                                            <strong>Acción a realizar cuando el usuario haga tap en la notificación</strong>
                                        </label>
                                        <DatoAdicionalSelect
                                                value={additional}
                                                onChange={(value) => {setAdditional(value); setParam1Value("");}}
                                                actions={actions}
                                        />
                                    </div>
                                    {
                                        additional.value !== "NONE" &&
                                        (actions.map((item, key) => {
                                            if(item.actionType == additional.value){
                                                return (
                                                <div key={key}>
                                                    <small>{ item.description }</small>
                                                    {("params" in item && Object.keys(item.params).length !== 0) &&
                                                    <div key={key} className="form-group">
                                                        <label htmlFor="param1">
                                                            <strong>{ item.params.label } *</strong>
                                                        </label>
                                                        <input
                                                            type= {item.params.type}
                                                            name="param1" 
                                                            id="param1" 
                                                            onChange={(e) => {setParam1Value(e.target.value)}} 
                                                            defaultValue={param1Value} 
                                                            className="form-control text-filter__form-control"
                                                        />
                                                    </div>
                                                    }
                                                </div>
                                                )
                                            }
                                        }))
                                    }

                                    <div className="form-group">
                                        <label htmlFor="prioridad">
                                            <strong>Prioridad</strong>
                                        </label>
                                        <div>
                                            <PrioridadSelect
                                                value={prioridad}
                                                onChange={(value) => setPrioridad(value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="envio">
                                            <strong>Seleccione un envío</strong>
                                        </label>
                                        <div className='form-control no-borders'>
                                            <div className='inputRadio'>
                                                <input id="segmentado" type="radio"
                                                    value="segmentado" name="tipoEnvio" checked={tipoEnvio == "segmentado"}
                                                    onChange={(event) => setTipoEnvio(event.target.value)}
                                                /> Envío segmentado
                                            </div>
                                            <div className='inputRadio ml-3'>
                                                <input id="especifico" type="radio"
                                                    value="especifico" name="tipoEnvio" checked={tipoEnvio == "especifico"}
                                                    onChange={(event) => setTipoEnvio(event.target.value)}/> Envío a dispositivos específicos
                                            </div>
                                        </div>
                                    </div>
                                   
                                    <div className={(tipoEnvio == 'especifico') ? 'pace-inactive' : ''}>
                                        <div className="form-group">
                                            <label htmlFor="sectores">
                                                <strong>Sectores</strong>
                                            </label>
                                            <div>
                                                <DropDownList
                                                    clave={sectores}
                                                    valor={sectores}

                                                    child="LineaProducto" 
                                                    valorHijo={lineasProducto}

                                                    name="sectores"
                                                    id="sectores" 
                                                    onChange={(event) => actualizarSectores(event)}
                                                    
                                                    componente={"EventSector"}
                                                    isMulti={true} />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="lineasProducto">
                                                <strong>Líneas de Producto</strong>
                                            </label>
                                            <div>
                                                <DropDownListChild  
                                                    metodo={"add"} 
                                                    clavePadre={sectores}

                                                    name="lineasProducto"
                                                    parent="Sector" 
                                                    id="lineasProducto"
                                                    onChange={(event) => setLineasProducto(event.target.value)}
                                                    clave={lineasProducto}
                                                    componente={"LineaProducto"} 
                                                    isMultiple={true} 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={(tipoEnvio == 'segmentado') ? 'pace-inactive' : ''}>
                                        <div className="form-group">
                                            <label htmlFor="lineasProducto">
                                                <strong>Dispositivos específicos</strong>
                                            </label>
                                            <div>
                                                <TextareaWithCounter
                                                    name="dispositivos" 
                                                    id="dispositivos" 
                                                    onChange={(e) => setDispositivos(e.target.value)} 
                                                    defaultValue={dispositivos} 
                                                    count={dispositivos}
                                                    placeholder="Ingrese los tokens separados por comas"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="text-center">
                            <button
                                disabled={sending} 
                                className='btn btn-lg btn-primary px-5 font-weight-bold text-uppercase'
                            >
                                {sending ? `Guardando..` : `Guardar`}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default CrearNotificacion